<ng-container *yssIsLoading="subFormIsLoading$ | async">
    <app-user-select-or-create
        [form]="form"
        [selectedUser]="action.customer"></app-user-select-or-create>
    <form [formGroup]="form">
        <div class="action-title-holder">
            <label class="padded-top-gray-label">Title:<span class="required">*</span></label>
            <input
                type="text"
                class="normal-text-input"
                formControlName="title"
                placeholder="Enter action title" />
        </div>
        <div>
            <label class="padded-top-gray-label">Details:<span class="required">*</span></label>
            <textarea
                class="textarea-styled"
                rows="4"
                placeholder="Enter Action Details"
                formControlName="description"></textarea>
        </div>
    </form>
</ng-container>
